import React, { useState } from 'react'
import i18n from 'live/services/i18n'
import { TableRow } from './tableRow'

interface IProps {
    country?: string
    factoryInfo: FactoryData
}
export function FactoryAssetInfo({ factoryInfo, country }: IProps): JSX.Element {
    const [isSelected, setIsSelected] = useState(false)
    const { factoryName, lines } = factoryInfo

    return (
        <React.Fragment>
            <TableRow
                assetName={factoryName}
                secondaryInfo={country}
                date={factoryInfo.lastUpdateTimestamp}
                author={factoryInfo.lastUpdateAuthor}
                isSelected={isSelected}
                setIsSelected={setIsSelected}
                countryName={country}
                rowType={'factory'}
            />

            {isSelected
                ? lines.map(lineInfo => {
                      const childName = lineInfo.lineName
                      const secondaryInfo = (
                          <React.Fragment>
                              <strong>{lineInfo.products?.length || 0}</strong>
                              {` ${i18n('products')}`}
                          </React.Fragment>
                      )

                      return (
                          <TableRow
                              key={factoryName + childName}
                              assetName={childName}
                              secondaryInfo={secondaryInfo}
                              date={lineInfo.lastUpdateTimestamp}
                              author={lineInfo.lastUpdateAuthor}
                              isSelected={isSelected}
                              setIsSelected={setIsSelected}
                              rowType={'line'}
                              countryName={country}
                              factoryName={factoryName}
                              numOfConfiguredProducts={lineInfo.products?.length || 0}
                          />
                      )
                  })
                : null}
        </React.Fragment>
    )
}
